/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const SpeechPlusAlt = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 14 14">
      <path
        d="M7 0C10.8599 0 14 2.59715 14 5.78809C13.9998 13.3873 7.50939 13.9612 7.44434 13.9658L7 14V11.1895C3.00935 11.1895 0.000267608 8.8677 0 5.78809C0 2.59715 3.14012 4.00991e-08 7 0ZM7 0.771484C3.59408 0.771485 0.823564 3.02159 0.823242 5.78711C0.823242 8.42706 3.47941 10.418 7 10.418H7.82324V13.1318C9.18948 12.8695 13.1768 11.6041 13.1768 5.78711C13.1764 3.02159 10.4059 0.771484 7 0.771484ZM7 3.08691C7.2272 3.08691 7.41196 3.25979 7.41211 3.47266V5.40234H9.4707C9.69794 5.4024 9.88281 5.57514 9.88281 5.78809C9.88275 6.00099 9.69791 6.17377 9.4707 6.17383H7.41211V8.10352C7.41184 8.31629 7.22713 8.48926 7 8.48926C6.77287 8.48926 6.58816 8.31629 6.58789 8.10352V6.17383H4.5293C4.30209 6.17377 4.11725 6.00099 4.11719 5.78809C4.11719 5.57514 4.30206 5.4024 4.5293 5.40234H6.58789V3.47266C6.58804 3.25979 6.7728 3.08691 7 3.08691Z"
        fill="black"
      />
    </BaseSvgIcon>
  )
}

export default SpeechPlusAlt
